import { Box, Heading, Text } from '@chakra-ui/react'
import Header from '../Header'
import PageTransition from '../components/PageTransition'

const IncrementalAllocations = (): JSX.Element => (
  <>
    <Header title="Incremental Allocations" subtitle="Manage your incremental investment allocations" />
    <PageTransition>
      <Box p={4}>
        <Heading as="h2" size="xl" mb={4}>Incremental Allocations</Heading>
        <Text fontSize="md">This page will help you manage and track incremental allocations for your investments.</Text>
      </Box>
    </PageTransition>
  </>
)

export default IncrementalAllocations
